<quill-editor
  (onEditorCreated)="editorCreated($event)"
  [formControl]="updateControl"
  [modules]="modules"
  [placeholder]="placeholder"
  [maxLength]="maxLength"
></quill-editor>
